import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import LoginPage from './pages/auth/LoginPage'
import RegisterPage from './pages/auth/RegisterPage'
import DashboardPage from './pages/DashboardPage'
import GamePage from './pages/game/GamePage'
import CountrySelectionPage from './pages/game/CountrySelectionPage'
import GameViewPage from './pages/game/GameViewPage'
import ProfilePage from './pages/ProfilePage'
import AIFeaturesPage from './pages/AIFeaturesPage'

function App() {
  const { isAuthenticated } = useAuthStore()

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={!isAuthenticated ? <LoginPage /> : <Navigate to="/dashboard" />} />
        <Route path="/register" element={!isAuthenticated ? <RegisterPage /> : <Navigate to="/dashboard" />} />
        
        {/* Protected routes */}
        <Route path="/dashboard" element={isAuthenticated ? <DashboardPage /> : <Navigate to="/login" />} />
        <Route path="/profile" element={isAuthenticated ? <ProfilePage /> : <Navigate to="/login" />} />
        <Route path="/game/new" element={isAuthenticated ? <GamePage /> : <Navigate to="/login" />} />
        <Route path="/game/select-country" element={isAuthenticated ? <CountrySelectionPage /> : <Navigate to="/login" />} />
        <Route path="/game/:gameId" element={isAuthenticated ? <GameViewPage /> : <Navigate to="/login" />} />
        <Route path="/ai-features" element={<AIFeaturesPage />} />
        
        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Layout>
  )
}

export default App